import { BUDGET_TYPE_SUCCESS } from "./BudgetTypeConstant";

 



export const budgetTypeReducer = (state = { budgetTypeData: [] }, action) => {

    switch (action.type) {
        case BUDGET_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                budgetTypeData: action.payload,
            }
        default:
            return state;
    }

}



